export default "__VITE_ASSET__tg_KVv7K__"